import { useTranslation } from "react-i18next";
import {
    useAgePartnerAtRetirement,
    useAgeSelfAtRetirement,
    useIsJointCalculation,
    useLegalRetirementAge,
    usePartnerIsRetiredAtPension,
    useSelfIsRetiredAtPension,
} from "./usePensionDate";

export const useAowWarning = () => {
    
    const { t } = useTranslation('pension');
    const isJointCalculation = useIsJointCalculation();
    const legalRetirementAge = useLegalRetirementAge();

    const selfAgeAtPensionStart = useAgeSelfAtRetirement();
    const partnerAgeAtPensionStart = useAgePartnerAtRetirement();

    const selfIsRetiredAtPension = useSelfIsRetiredAtPension();
    const partnerIsRetiredAtPension = usePartnerIsRetiredAtPension();

    const singleCalculationWarningText = t('pension-cocktail-warning-aow-single', {legalRetirementAge});
    const jointCalculationWarningText = t('pension-cocktail-warning-aow-together', {legalRetirementAge});

    const NO_WARNING = { scenario: 0, warning: false, text:''}
    const WARNING_SINGLE = { scenario: 1, warning: true, text: singleCalculationWarningText};
    const WARNING_JOINT = { scenario: 1, warning: true, text: jointCalculationWarningText};

    if (selfAgeAtPensionStart === undefined)
        return NO_WARNING;

    // Single calculation
    const selfYoungerThanLegalRetirementAgeAtPension = selfAgeAtPensionStart < legalRetirementAge;
    const selfHasAowGap = selfIsRetiredAtPension && selfYoungerThanLegalRetirementAgeAtPension;

    if (!isJointCalculation && selfHasAowGap){
        return WARNING_SINGLE;
    }

    if (!isJointCalculation || partnerAgeAtPensionStart === undefined)
        return NO_WARNING;

    // Joined calculation
    const partnerYoungerThanLegalRetirementAgeAtPension = partnerAgeAtPensionStart < legalRetirementAge;
    const partnerHasAowGap = partnerIsRetiredAtPension && partnerYoungerThanLegalRetirementAgeAtPension;

    if (selfHasAowGap || partnerHasAowGap)
        return WARNING_JOINT;

    return NO_WARNING;
}
